import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.css';

class Menu extends React.Component {
  constructor(props) {
    super(props);

    props.callback(this.setMenu);
    this.state = { type: null, isVisible: false, list: [], action: null };
  }

  setMenu = (type, list, action) => {
    const isVisible = this.state.type === type ? !this.state.isVisible : true;
    this.setState({ type, list, isVisible, action });
  };

  select = (item, index) => {
    this.state.action && this.state.action(item, index);
    this.setState({ isVisible: false });
  };

  toggleVisibility = () => {
    this.setState({ isVisible: !this.state.isVisible });
  };

  render() {
    this.props.player.toggleClass(
      'xing-vjs-menu-visible',
      this.state.isVisible
    );
    if (!this.state.isVisible) {
      return null;
    }
    return (
      <div className="xing-vjs-menu-container" onClick={this.toggleVisibility}>
        <ul className="xing-vjs-menu">
          {this.state.list.map((item, index) => (
            <li
              className={cx(styles.menuItem, {
                [styles.menuItemSelected]: item.selected,
              })}
              key={item.id}
            >
              <button
                type="button"
                className={styles.itemButton}
                onClick={() => this.select(item, index)}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

Menu.propTypes = {
  player: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
};

export default Menu;
